import React, { useEffect, useRef, useState } from "react";
import { decryptData, formatDate, formatDateNewYYYYMMDD, formatDateYYYYMMDD, handleAlphaSpaceChange, handleAlphaSpacePaste, sanitizeDropdownInput, validateFile } from "../../../CommonMethhods/CommonMethods";
import axiosInstance, { axiosFormDataInstance } from "../../../CommonMethhods/axiosInstance";
import { Dealer_Mapping } from "../../../Configuration/API_URL";
import { toast } from "react-toastify";
import fileIcon from "../../../asset/images/file-withbg.svg";
import attachIcon from "../../../asset/images/attach.svg";
import closeIcon from "../../../asset/images/close-gray.svg";
import uploadIcon from "../../../asset/images/upload-file.svg";
import { Controller, useForm } from "react-hook-form";
import SmallLoader from "../../../Components/Common/smallLoader";
import { useDebounce } from "../../../Components/useDebounce";
import SearchDropdown from "../../../CommonMethhods/searchDropdown";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomTradeDate from "../../../CommonMethhods/CustomDate";
import moment from "moment";

function NewMappingReq({ selectedRequest, isFromMyRequest, setSelectedSR, refreshHistory, rowData, isReadOnly,
  setActiveTab, setShowConfirmation, setConfirmationData }) {
  const makerId = localStorage.getItem("userName");
  const [submitLoader, setSubmitLoader] = useState(false);
  const [draftLoader, setDraftLoader] = useState(false);
  const fileInputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [searchClCode, setSearchClCode] = useState("");
  const [clError, setClError] = useState("");
  const [clLoader, setClLoader] = useState(false);
  const [dealerList, setDealerList] = useState([]);
  const [showDealerDropdown, setShowDealerDropdown] = useState(false);
  const [searchDlCode, setSearchDlCode] = useState("");
  const [dlError, setDlError] = useState("");
  const [dlLoader, setDlLoader] = useState(false);
  const debouncedValue = useDebounce(searchClCode, 1000);
  const debouncedDlValue = useDebounce(searchDlCode, 1000);
  const [approvalDocLink, setApprovalDocLink] = useState("");

  const newMappingValidation = Yup.object().shape({
    clientCode: Yup.string()
      .required("UCC / Client Code is required"),

    dealerCode: Yup.string()
      .required("New Dealer Code/Name is required"),

    effectiveDate: Yup.string()
      .required("Effective Date is required")
      .test(
        "valid-date",
        "Please enter a valid date",
        value => moment(value, "DD-MM-YYYY", true).isValid()
      )
      .test(
        "future-date",
        "Effective Date cannot be before the request date",
        value =>
          moment(value, "DD-MM-YYYY").isSameOrAfter(moment(), "day")
      ),

    reasonType: Yup.string()
      .required("Reason Type is required"),

    reason: Yup.string().when("reasonType", {
      is: "others",
      then: (schema) =>
        schema
          .required("Reason is required")
          .min(10, "Reason must be at least 10 characters")
          .max(500, "Reason cannot exceed 500 characters"),
      otherwise: (schema) => schema.notRequired(),
    }),

    approvalDoc: Yup.mixed()
      .required("Approval document is required"),
  });

  const {
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors, isValid }
  } = useForm({
    resolver: yupResolver(newMappingValidation),
    mode: "onChange",
    defaultValues: {
      clientCode: "",
      dealerCode: "",
      effectiveDate: null,
      reasonType: "",
      reason: "",
      approvalDoc: null,
      branch: ""
    }
  });
  const reasonOptions = [
    "newMapping",
    "updateMapping",
    "others"
  ];
  const buttonRefs = useRef([]);
  const reasonRefs = useRef([]);
  const reasonTextareaRef = useRef(null);

  const branch = watch("branch");
  const reasonText = watch("reason") || "";
  const currentDate = formatDate(new Date());
  const selectedReasonType = watch("reasonType");

  const reasonLength = reasonText.trim().length;

  const pendingMinChars = Math.max(0, 10 - reasonLength);
  const remainingChars = 500 - reasonLength;

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const submitSingleMapData = async (formValues, isDraft = false) => {
    if (isDraft) {
      setDraftLoader(true);
    } else {
      setSubmitLoader(true);
    }

    const finalReason =
      formValues.reasonType === "newMapping"
        ? "New mapping"
        : formValues.reasonType === "updateMapping"
          ? "Update existing mapping"
          : formValues.reason;

    const formData = new FormData();
    formData.append("client-code", formValues.clientCode);
    formData.append("new-dealer-code", formValues.dealerCode);
    formData.append("effective-date", formatDateNewYYYYMMDD(formValues.effectiveDate));
    formData.append("reason", finalReason);
    formData.append("branch", formValues.branch);
    formData.append("approval-doc", formValues.approvalDoc);

    try {

      let url = "";
      let getDetails;

      if (isFromMyRequest) {
        url = `${Dealer_Mapping.singleMappingSubmit}/${selectedRequest?.batchId}/submit${isDraft ? "?draft=true" : ""
          }`;

        getDetails = await axiosFormDataInstance.put(url, formData);
      } else {
        url = `${Dealer_Mapping.singleMappingSubmit}/submit${isDraft ? "?draft=true" : ""
          }`;

        getDetails = await axiosFormDataInstance.post(url, formData);
      }

      const decrypted = JSON.parse(
        decryptData(getDetails?.data)
      );
      console.log(decrypted, "viewTable");
      if (decrypted?.status === 0) {

        if (isFromMyRequest) {
          setSelectedSR(null);
          refreshHistory?.();
        } else if(decrypted?.data?.validityStatus?.toLowerCase() === "valid") {
          setConfirmationData(decrypted?.data);
          setShowConfirmation(true);
          
        }
        if(decrypted?.data?.validityStatus?.toLowerCase() === "valid") {
          toast.success(decrypted?.message);
        }else{
          toast.error(decrypted?.data?.failures[0])
        }
        
      } else {
        toast.error(decrypted?.message);
      }
    } catch (error) {
      const catchResp = JSON.parse(
        decryptData(error?.response?.data)
      );
      console.log(error, catchResp,"catchResp");
      toast.error(catchResp?.message)

    } finally {
      if (isDraft) {
        setDraftLoader(false);
      } else {
        setSubmitLoader(false);
      }
    }
  };

  const onSubmit = (data) => {
    submitSingleMapData(data, false);
  };

  useEffect(() => {
    if (selectedReasonType === "others") {
      setTimeout(() => {
        reasonTextareaRef.current?.focus();
      }, 0);
    }
  }, [selectedReasonType]);

  const onSaveDraft = (data) => {
    submitSingleMapData(data, true);
  };

  useEffect(() => {
    if (!isFromMyRequest || !rowData?.requests?.length) return;

    const request = rowData.requests[0];
    setSearchClCode(request.ucc || "");
    setSearchDlCode(request.newDealerCode || "");

    setValue("clientCode", request.ucc || "", {
      shouldValidate: true,
    });

    setValue("dealerCode", request.newDealerCode || "", {
      shouldValidate: true,
    });

    setValue("branch", request.branch || "");
    setValue(
      "effectiveDate",
      request.startDate
        ? moment(request.startDate, "YYYY-MM-DD").format("DD-MM-YYYY")
        : ""
    );

    // setValue(
    //   "effectiveDate",
    //   request.startDate
    //     ? new Date(request.startDate).toISOString().split("T")[0]
    //     : ""
    // );
    let reasonType = "others";

    if (request.reason === "New mapping") {
      reasonType = "newMapping";
    } else if (request.reason === "Update existing mapping") {
      reasonType = "updateMapping";
    }

    setValue("reasonType", reasonType);

    if (reasonType === "others") {
      setValue("reason", request.reason || "");
    } else {
      setValue("reason", "");
    }
    setApprovalDocLink(rowData.approvalDocLink || "");
    setValue(
      "approvalDoc",
      rowData.approvalDocLink || "existing-file",
      {
        shouldValidate: true,
      }
    );

  }, [rowData, isFromMyRequest, setValue]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!validateFile(file)) {
      e.target.value = "";
      return;
    }
    setUploadedFile(file);
    setValue("approvalDoc", file, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const fetchDropdownData = async ({
    url,
    searchText,
    setLoader,
    setList,
    setError
  }) => {
    setLoader(true);
    setError("");

    try {
      const response = await axiosInstance.get(
        `${Dealer_Mapping.clientCodeList}/${url}?prefix=${searchText}`
      );

      const decrypted = JSON.parse(
        decryptData(response?.data)
      );

      if (decrypted?.status === 0) {
        setList(decrypted?.data || []);
      } else {
        setList([]);
        setError(decrypted?.message);
      }

    } catch (error) {
      console.log(error);
      setList([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!debouncedValue) return;

    fetchDropdownData({
      url: "clients",
      searchText: debouncedValue,
      setLoader: setClLoader,
      setList: setClientList,
      setError: setClError
    });
  }, [debouncedValue]);

  useEffect(() => {
    if (!debouncedDlValue) return;

    fetchDropdownData({
      url: "dealers",
      searchText: debouncedDlValue,
      setLoader: setDlLoader,
      setList: setDealerList,
      setError: setDlError
    });
  }, [debouncedDlValue]);

  const isReasonValid =
    selectedReasonType !== "others" || reasonLength >= 10;

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();

    if (isReadOnly) return;

    const file = e.dataTransfer.files[0];

    if (!file) return;

    // Reuse your existing handler
    handleFileChange({
      target: {
        files: [file],
        value: "",
      },
    });
  };

  const handlePreviewFile = () => {
    if (uploadedFile) {
      const fileUrl = URL.createObjectURL(uploadedFile);
      window.open(fileUrl, "_blank", "noopener,noreferrer");
      setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
      return;
    }

    if (approvalDocLink) {
      window.open(approvalDocLink, "_blank", "noopener,noreferrer");
    }
  };

  const handleButtonKeyDown = (e, index) => {
    switch (e.key) {
      case "ArrowRight":
        e.preventDefault();
        if (index < buttonRefs.current.length - 1) {
          buttonRefs.current[index + 1]?.focus();
        }
        break;

      case "ArrowLeft":
        e.preventDefault();
        if (index > 0) {
          buttonRefs.current[index - 1]?.focus();
        }
        break;

      case "Enter":
      case " ":
        e.preventDefault();
        e.currentTarget.click();
        break;

      default:
        break;
    }
  };

  return (
    <div className="card-tab-details">
      <div className="dealer-mapping-main">
        <div className="ckr-page">
          <div className="info-banner info-flex">
            <div className="wrap-infoicon">
              <img src={fileIcon} alt="file icon" />
            </div>
            <span className="banner-text">
              <span className="bold-text">For multiple records use Bulk Upload</span>{" "}
              On submission, Checker receives an email notification automatically.
            </span>
          </div>

          <div className="ckr-section">
            <div className="draft-header">
              {selectedRequest?.batchId ?
                <div className="status-content">
                  <span className="ckr-section-title">{selectedRequest?.batchId}</span>
                  {selectedRequest?.status !== "" ?
                    <span
                      className={`${selectedRequest.status.toLowerCase() === "pending" ? "status-pending" :
                        selectedRequest.status.toLowerCase() === "approved" ? "status-approved" :
                          selectedRequest.status.toLowerCase() === "rejected" ? "status-rejected" :
                            selectedRequest.status.toLowerCase() === "draft" ? "status-draft" : ""
                        }`}>
                      {selectedRequest?.status}
                    </span>
                    : "-"}

                </div>
                :
                <span className="ckr-section-title">Single client – dealer mapping</span>
              }
            </div>

            <div className="new-mapping-content">
              <div className="wrap-mapping-content mb-20">
                <div className="internal-section">
                  <label className="section-label">Request Date</label>
                  <input
                    className="section-input"
                    type="text"
                    value={currentDate}
                    disabled
                  />
                </div>

                <div className="internal-section">
                  <label className="section-label">Maker ID</label>
                  <input
                    className="section-input"
                    type="text"
                    placeholder="RequestDate"
                    value={makerId}
                    disabled
                  />
                </div>
              </div>

              <div className="wrap-mapping-content mb-20">
                <div className="internal-section">
                  <label className="section-label">UCC / Client Code <span className="error-mark">*</span></label>

                  <SearchDropdown
                    value={searchClCode}
                    placeholder="Type UCC or Client Code"
                    showDropdown={showClientDropdown}
                    setShowDropdown={setShowClientDropdown}
                    data={clientList}
                    loading={clLoader}
                    error={clError}

                    onInputChange={(e) => {
                      const input = sanitizeDropdownInput(e, {
                        allowSpace: true,
                        maxLength: 8
                      });

                      setSearchClCode(input);
                      setValue("branch", "", {
                        shouldValidate: true,
                        shouldDirty: true,
                      });
                      setValue("clientCode", input, {
                        shouldValidate: true,
                        shouldDirty: true,
                      });
                      setShowClientDropdown(true);

                      if (!input) {
                        setClientList([]);
                        setClError("");
                        setShowClientDropdown(false);
                      }
                    }}
                    onSelect={(item) => {

                      setSearchClCode(item?.clientCode);

                      setValue(
                        "clientCode",
                        item?.clientCode,
                        {
                          shouldValidate: true,
                        }
                      );

                      setValue(
                        "branch",
                        item?.branch,
                        {
                          shouldValidate: true,
                        }
                      );

                      setShowClientDropdown(false);
                    }}
                    disabled={isReadOnly}
                  />

                  {errors.clientCode && (
                    <span className="ErrorMsg">
                      {errors.clientCode.message}
                    </span>
                  )}
                </div>

                <div className="internal-section">
                  <label className="section-label">New Dealer Code/Name <span className="error-mark">*</span></label>

                  <SearchDropdown
                    value={searchDlCode}
                    placeholder="Enter New Dealer Code/Name"
                    showDropdown={showDealerDropdown}
                    setShowDropdown={setShowDealerDropdown}
                    data={dealerList}
                    loading={dlLoader}
                    error={dlError}
                    onInputChange={(e) => {
                      const value = sanitizeDropdownInput(e, {
                        allowSpace: true,
                        maxLength: 50
                      });

                      setSearchDlCode(value);
                      setValue("dealerCode", value, {
                        shouldValidate: true,
                        shouldDirty: true,
                      });
                      setShowDealerDropdown(true);
                      if (!value) {
                        setDealerList([]);
                        setDlError("");
                        setShowDealerDropdown(false)
                      }
                    }}
                    onSelect={(item) => {
                      setSearchDlCode(item?.dealerCode);
                      setValue("dealerCode", item?.dealerCode, { shouldValidate: true, });
                      setShowDealerDropdown(false);
                    }}
                    disabled={isReadOnly}
                  />

                  {errors.dealerCode && (
                    <span className="ErrorMsg">
                      {errors.dealerCode.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="wrap-mapping-content mb-20">
                <div className="internal-section enable-input">
                  <label className="section-label">Effective Date <span className="error-mark">*</span></label>
                  <Controller
                    name="effectiveDate"
                    control={control}
                    render={({ field }) => (
                      <CustomTradeDate
                        idPrefix="effectiveDate"
                        value={field.value || ""}
                        onChange={field.onChange}
                      disabled={isReadOnly}
                      />
                    )}
                  />

                  {errors.effectiveDate && (
                    <span className="ErrorMsg">
                      {errors.effectiveDate.message}
                    </span>
                  )}
                </div>

                <div className="internal-section">
                  <label className="section-label">Branch</label>
                  <input
                    className="section-input"
                    type="text"
                    placeholder="Add Branch"
                    disabled
                    value={branch || ""}
                    {...register("branch")}
                  />
                </div>
              </div>

              <div className="wrap-mapping-content upload-sec mb-20">
                <div className="internal-section wrap-file-upload">
                  <label className="section-label">Attach Approval Document from Head</label>
                  {!uploadedFile && approvalDocLink === "" ?
                    <>
                      <div className="wrap-drag-drop tab-style"
                        onFocus={() => console.log("Focused")}
                        tabIndex={0}
                        role="button"
                        onClick={handleUploadClick}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleUploadClick();
                          }
                        }}>

                        <div className="upload-area">
                          <img src={attachIcon} alt="attach icon" />

                          <div className="wrap-input-cont">
                            <span className="drag-text">Click to browse or drag & drop your Excel file</span>
                            <span className="upload-info">
                              Supports .pdf, .jpg, .png or click to browse · Max 5 MB
                            </span>
                            <input
                              type="file"
                              ref={fileInputRef}
                              hidden
                              accept=".pdf,.jpg,.png"
                              id="fileUpload"
                              onChange={handleFileChange}
                              disabled={isReadOnly}

                            />
                            <label className="select-file">Select File</label>
                          </div>
                        </div>
                      </div>
                      {errors.approvalDoc && (
                        <span className="ErrorMsg">
                          {errors.approvalDoc.message}
                        </span>
                      )}
                    </>

                    :
                    <div className="dealer-doc-upload">

                      <div className="wrap-upload-section">

                        <div className="wrap-docname">
                          <img src={uploadIcon} alt="upload icon" />

                          <span className="upload-doc-btn"
                            tabIndex={0}
                            role="button"
                            onClick={handlePreviewFile}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handlePreviewFile();
                              }
                            }}
                          >
                            {uploadedFile?.name || rowData?.approvalDocFilename}
                          </span>
                        </div>

                        <img
                          className="close"
                          src={closeIcon}
                          alt="close"
                          style={{
                            cursor: isReadOnly ? "not-allowed" : "pointer",
                            pointerEvents: isReadOnly ? "none" : "auto",
                            opacity: isReadOnly ? 0.5 : 1,
                          }}
                          onClick={() => {
                            if (isReadOnly) return;

                            setUploadedFile(null);
                            setApprovalDocLink("");
                            setValue("approvalDoc", null, {
                              shouldValidate: true,
                            });

                            if (fileInputRef.current) {
                              fileInputRef.current.value = "";
                            }
                          }}
                        />

                      </div>

                    </div>
                  }
                </div>
                <div className="internal-section">
                  <label className="section-label">Reason for Change<span className="error-mark">*</span></label>

                  <div className="wrap-radio-section" role="radiogroup" aria-label="reason-label">
                    <label className="radio-option">
                      <input
                        type="radio"
                        value="newMapping"
                        {...register("reasonType")}
                        disabled={isReadOnly}
                        ref={(e) => {
                          register("reasonType").ref(e);
                          reasonRefs.current[0] = e;
                        }}
                      />
                      <span>New mapping</span>
                    </label>

                    <label className="radio-option">
                      <input
                        ref={(e) => {
                          register("reasonType").ref(e);
                          reasonRefs.current[1] = e;
                        }}
                        type="radio"
                        value="updateMapping"
                        {...register("reasonType")}
                        disabled={isReadOnly}
                      />
                      <span>Update existing mapping</span>
                    </label>

                    <label className="radio-option">
                      <input
                        ref={(e) => {
                          register("reasonType").ref(e);
                          reasonRefs.current[2] = e;
                        }}
                        type="radio"
                        value="others"
                        {...register("reasonType")}
                        disabled={isReadOnly}
                      />
                      <span>Others</span>
                    </label>
                  </div>

                  {errors.reasonType && (
                    <span className="ErrorMsg">
                      {errors.reasonType.message}
                    </span>
                  )}

                  {selectedReasonType === "others" &&
                    <>
                      <textarea
                        ref={reasonTextareaRef}
                        maxLength={500}
                        minLength={10}
                        className="section-input textarea"
                        placeholder="Type reason here"
                        {...register("reason", {
                          required: "Reason is required"
                        })}
                        disabled={isReadOnly}
                        onChange={(e) => handleAlphaSpaceChange(e, "reason", setValue, 500)}
                        onPaste={(e) =>
                          handleAlphaSpacePaste(
                            e,
                            "reason",
                            getValues,
                            setValue,
                            500
                          )
                        }
                      />
                      <div className="char-count">
                        {pendingMinChars > 0 ? (
                          <span className="ErrorMsg">
                            Minimum {pendingMinChars} character
                            {pendingMinChars > 1 ? "s are" : " is"} required
                            ({reasonLength}/500)
                          </span>
                        ) : (
                          <span>{remainingChars} characters remaining</span>
                        )}
                      </div>
                    </>
                  }

                </div>

              </div>
            </div>

            <div className="mapping-footer-actions">
              {!isReadOnly ?
                <>
                  <button
                    ref={(el) => (buttonRefs.current[0] = el)}
                    onKeyDown={(e) => handleButtonKeyDown(e, 0)}
                    className={`back-btn ${!isValid || draftLoader || isReadOnly ? "disabled-btn-sec" : ""
                      }`}
                    disabled={!isValid || !isReasonValid || draftLoader || isReadOnly}
                    onClick={handleSubmit(onSaveDraft)}
                  >
                    {draftLoader ? <SmallLoader /> : "SAVE AS DRAFT"}
                  </button>
                  <button
                    ref={(el) => (buttonRefs.current[1] = el)}
                    onKeyDown={(e) => handleButtonKeyDown(e, 1)}
                    className={`submit-btns ${!isValid || submitLoader || isReadOnly ? "disabled-btn" : ""
                      }`}
                    disabled={!isValid || !isReasonValid || submitLoader || isReadOnly}
                    onClick={handleSubmit(onSubmit)}
                  >
                    {submitLoader ? <SmallLoader /> : "SUBMIT FOR APPROVAL"}
                  </button>
                </>
                :
                <button className="back-btn"
                  onClick={() => setSelectedSR(null)}
                >
                  CANCEL
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewMappingReq;
